import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { UsuarioFormComponent } from '../usuario-form/usuario-form.component';

import { UsuarioService } from '../services/usuario.service';
import { UsuarioViewModel } from '../models/usuario-view-model';

import { AngularFireAuth } from '@angular/fire/auth';
import { User } from '../../../autenticacion/models/user';

@Component({
    selector: 'app-usuario-list',
    templateUrl: './usuario-list.component.html',
    styleUrls: ['./usuario-list.component.scss']
})
export class UsuarioListComponent implements OnInit {

    user: User;
    editable : boolean = false;

    constructor(private usuarioService: UsuarioService, 
        private modalService: NgbModal,
        private afAuth: AngularFireAuth) { }

    ngOnInit(): void {

        this.afAuth.user.subscribe(user => {
            if (user) {
                this.user = user;
                if (user.email == 'espirou79@gmail.com'){
                    this.editable = true;
                }
            }
        })
        
        this.loadUsuarios();
    }

    clickAddUsuario() {
        const modal = this.modalService.open(UsuarioFormComponent);
        modal.result.then(
            this.handleModalUsuarioFormClose.bind(this),
            this.handleModalUsuarioFormClose.bind(this));
    }

    handleModalUsuarioFormClose(response: any) {
        // is response an object?
        if (response === Object(response)) {
            if (response.editMode == 'C') {
                response.usuario.id = response.id;
                this.usuarios.unshift(response.usuario);
            } else if (response.editMode == 'M') {
                let index = this.usuarios.findIndex(value => value.id == response.id);
                this.usuarios[index] = response.usuario;
            } else if (response.editMode == 'D') {
                let index = this.usuarios.findIndex(value => value.id == response.id);
                this.usuarios.splice(index, 1);
            }
        }
    }

    usuarios: UsuarioViewModel[] = [];

    loadUsuarios() {
        this.usuarioService.getUsuarios().subscribe(response => {
            this.usuarios = [];
            response.docs.forEach(value => {
                const data = value.data();
                const id = value.id;
                const usuario: UsuarioViewModel = {
                    id: id,
                    nombre: data.nombre,
                    fechaAlta: data.fechaAlta,
                    _fechaModificacion: data.fechaModificacion,
                    _userModificacion: data.userModificacion,
                    _lgBaja: data.lgBaja,
                    _fechaBaja: data.fechaBaja,
                    _userBaja: data.userBaja,
                    rolId: data.rolId,
                };

                this.usuarios.push(usuario);
            });
        });
    }

    handleEditClick(usuario: UsuarioViewModel) {
        const modal = this.modalService.open(UsuarioFormComponent);
        modal.result.then(
            this.handleModalUsuarioFormClose.bind(this),
            this.handleModalUsuarioFormClose.bind(this)
        )
        modal.componentInstance.editMode = 'M';
        modal.componentInstance.usuario = usuario;
    }
}
